import { render, staticRenderFns } from "./GetInfoWithIban.vue?vue&type=template&id=5db94b2a"
import script from "./GetInfoWithIban.vue?vue&type=script&lang=js"
export * from "./GetInfoWithIban.vue?vue&type=script&lang=js"
import style0 from "./GetInfoWithIban.vue?vue&type=style&index=0&id=5db94b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports